module.exports = __webpack_public_path__ + "static/living-08ebd0a589c6af49a86cbd28d46eb85f.jpg";